var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotFound = function SvgNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#335cea",
    d: "M495.88 424.25c0-25.2-20.44-45.64-45.64-45.64s-45.64 20.44-45.64 45.64v257.99H220.3v-455.6h173.68v53.25c22.19-39.93 76.54-62.12 130.58-62.12 99.2 0 155.14 62.12 155.14 174.63v289.84H495.4z"
  })));
};
export default SvgNotFound;